import { IGraphApiError, GraphApiError } from './graphApiError';

export class GraphApiRootError {
	public static parse(data: IGraphApiRootError): GraphApiRootError {
		const error: GraphApiRootError = new GraphApiRootError();
		if ((data.error !== undefined) && (data.error != null)) {
			error.error = GraphApiError.parse(data.error);
		}
		return error;
	}
	public error: GraphApiError = new GraphApiError();
}

export interface IGraphApiRootError {
	error?: IGraphApiError;
}
